<template lang="pug">
	div(v-if="subscriptionPayment && (subscriptionPayment.has_trial || hasTrial)" style="padding-bottom: 1.5rem;")
		p.subtitle.has-text-centered(style="margin-bottom:0.2rem;")
			strong {{ $t('profile.enter_last_info').toUpperCase() }}

		p.subtitle.subtitle-payment(v-if="subscriptionPayment.special_trial" style="margin-bottom:0.5rem;")
			| {{ $t('profile.payment_info_to_continue', { 'date': getDate(subscriptionPayment.trial) }) + ' ' }}
			| {{ $t('profile.payment_info_to_continue1') + ' ' }}
			span(style="font-weight: 700;")
				| {{ $t('profile.payment_info_to_continue2') + ' ' }}
			| {{ $t('profile.payment_info_to_continue3') }}
		p.subtitle.subtitle-payment(v-else style="margin-bottom:0.5rem;")
			| {{ $t('profile.payment_info_to_continue_month') + ' ' }}
			| {{ $t('profile.payment_info_to_continue1') + ' ' }}
			span(style="font-weight: 700;")
				| {{ $t('profile.payment_info_to_continue2') + ' ' }}
			| {{ $t('profile.payment_info_to_continue3') }}

		p.subtitle.subtitle-payment(style="margin-bottom:0.5rem;")
			span(style="font-weight: 700;")
				| {{ $t('profile.payment_info_to_continue4') + ' ' }}
			br
			| {{ $t('profile.payment_info_to_continue5') }}
			ol(style="padding-left:1.1rem")
				li {{ $t('profile.payment_info_guide_1') }}
				li {{ $t('profile.payment_info_guide_2') }}
				li {{ $t('profile.payment_info_guide_3') }}
		p.subtitle.subtitle-payment
			| {{ $t('profile.payment_info_guide_4') }}

	div(v-else-if="subscriptionPayment" style="padding-bottom: 1.5rem;")
		p.subtitle.has-text-centered(style="margin-bottom:0.2rem;")
			strong {{ $t('profile.enter_last_info_payment').toUpperCase() }}
</template>

<script>
export default {
	props: {
		subscriptionPayment: Object,
		hasTrial           : Boolean
	},
	methods: {
		getDate(timestamp) {
			if (timestamp === null || timestamp === undefined) return ''
			const d = new Date(timestamp * 1000)
			const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
			const month = months[d.getMonth()]

			return d.getDate() + ' ' + this.$t('time.month.' + month) + ' ' + d.getFullYear()
		}
	}
}
</script>
